/**
 * Height (px) of a single signal icon row — must match `IconContainer` height in CalendarAppointmentSignalRow.
 * Also used as the minimum container query threshold in CalendarAppointment.styles.tsx:
 * below this height, all signal icons are hidden and replaced by a single "show all" overflow badge.
 */
export const SIGNAL_ICON_ROW_PX = 20;

/**
 * Upper bound (30px) for the "one icon visible" container query range in CalendarAppointment.styles.tsx.
 * When the appointment height is between SIGNAL_ICON_ROW_PX and this value, only the first signal icon
 * is shown for columns with 3+ icons; the remaining icons are collapsed into an overflow badge.
 */
export const SIGNAL_THREE_ICON_ONE_ROW_MAX_PX = SIGNAL_ICON_ROW_PX * 1.5;

/** Container query thresholds (L/XL); used in CalendarAppointment.styles.tsx. */
export const SIGNAL_HEIGHT_L_PX = 70;
export const SIGNAL_HEIGHT_XL_PX = 90;
